import * as React from "react";
import { WarningOutlined } from "@ant-design/icons";
import { Button } from "antd";

type Props = {
    actionLink?: {
        disabled?: boolean;
        label: React.ReactNode;
        onClick: () => void;
    };
    className?: string;
    containerClassName?: string;
    description: React.ReactNode;
    showIcon?: boolean;
    title?: React.ReactNode;
};

const WarningBanner: React.FC<Props> = ({
    actionLink,
    className,
    containerClassName,
    description,
    showIcon = true,
    title,
}) => {
    const resolvedContainerClassName = containerClassName
        ? `app-modal__warning-container ${containerClassName}`
        : "app-modal__warning-container";
    const resolvedClassName = className
        ? `app-modal__warning-banner ${className}`
        : "app-modal__warning-banner";

    return (
        <div className={resolvedContainerClassName}>
            <div className={resolvedClassName}>
                {showIcon ? (
                    <WarningOutlined className="app-modal__warning-icon" />
                ) : null}
                <div className="app-modal__warning-content">
                    {title ? (
                        <div className="app-modal__warning-title">{title}</div>
                    ) : null}
                    <div className="app-modal__warning-text">{description}</div>
                </div>
                {actionLink ? (
                    <Button
                        className="app-modal__warning-action"
                        type="link"
                        disabled={actionLink.disabled}
                        onClick={actionLink.onClick}
                    >
                        {actionLink.label}
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

export default WarningBanner;
